export const formatDate = (d, options) => {
  const date = typeof d === 'string' ? new Date(d) : d
  if (isNaN(date)) {
    return ''
  }

  return date.toLocaleDateString(
    'de-DE',
    options ?? {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }
  )
}

export const getFormattedDateRange = (date1, date2) => {
  const d1 = typeof date1 === 'string' ? new Date(date1) : date1
  const d2 = typeof date2 === 'string' ? new Date(date2) : date2

  // not in same year
  if (d1.getYear() !== d2.getYear()) {
    return {
      from: formatDate(d1, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      }),
      to: formatDate(d2, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      }),
    }
  }

  // same year, different month
  if (d1.getMonth() !== d2.getMonth()) {
    return {
      from: formatDate(d1, {
        day: 'numeric',
        month: 'short',
      }),
      to: formatDate(d2, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      }),
    }
  }

  // same year, same, month, different day
  if (d1.getDay() !== d2.getDay()) {
    return {
      from: formatDate(d1, {
        day: 'numeric',
      }) + '.',
      to: formatDate(d2, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }),
    }
  }

  // same year, same, month, same day
  return {
    sameDay: true,
    from: formatDate(d1, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }),
    to: formatDate(d2, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }),
  }
}
